module.exports = __webpack_public_path__ + "static/img/app-train-3.e2329cbc.png";